module.exports = __webpack_public_path__ + "8da9ea4bbb8889c69e1c6549de596659.png";